import { db, authReady, doc, collection, query, getDocs, runTransaction, orderBy, limit } from "//supercolonial.com/cdn/shop/t/4/assets/firebase-config.js?v=7030180030326981821781200190";

export async function getDepartamentos() {
    await authReady;   // token anónimo antes de leer (por si las reglas lo exigen)
    const departamentsRef = collection(db, "Departamentos");
    const q = query(departamentsRef);
    const querySnapshot = await getDocs(q);
    const departamentos = querySnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    return departamentos;
}

// Último pedido generado = mayor Numero (Contadores/Pedidos.Actual). Solo lectura.
export async function getUltimoPedido() {
    await authReady;
    const pedidosRef = collection(db, "Pedidos");
    const q = query(pedidosRef, orderBy("Numero", "desc"), limit(1));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) return null;
    const d = querySnapshot.docs[0];
    return { id: d.id, ...d.data() };
}

export async function createPedido(pedido) {
    const contadorRef = doc(db, "Contadores", "Pedidos");   // doc específico, no la colección

    try {
        await authReady;   // asegura token anónimo antes de escribir (reglas request.auth != null)

        const numero = await runTransaction(db, async (transaction) => {
            const contadorDoc = await transaction.get(contadorRef);
            if (!contadorDoc.exists()) throw Error("Contador document does not exist!");

            const newNumPedido = contadorDoc.data().Actual + 1;

            // id auto-generado en la colección Pedidos (reemplaza createId del compat SDK)
            const nuevoPedidoRef = doc(collection(db, "Pedidos"));
            const newPedido = Object.assign(pedido, {
                uid: nuevoPedidoRef.id,
                Numero: newNumPedido,
            });

            transaction.set(nuevoPedidoRef, newPedido);
            transaction.update(contadorRef, { Actual: newNumPedido });

            return newNumPedido;
        });

        return numero;
    } catch (err) {
        // No mostramos UI aquí — el caller (sección) decide cómo notificar al usuario
        console.error("Error al crear el pedido:", err);
        throw err;
    }
}
